const HTML_ESCAPE_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

export function escapeHtml(value) {
  return String(value == null ? "" : value).replace(/[&<>"']/g, function(char) {
    return HTML_ESCAPE_MAP[char];
  });
}

/**
 * Render WhatsApp-style text to a small, safe HTML subset.
 * Input is escaped first, so user content can never become executable HTML.
 * Supported: ```mono```, *bold*, _italic_, ~strike~, line breaks.
 */
export function renderWhatsAppHtml(message, replacements) {
  var text = String(message == null ? "" : message);
  var values = replacements || {};

  Object.keys(values).forEach(function(key) {
    text = text.split("${" + key + "}").join(String(values[key]));
  });

  text = escapeHtml(text);

  // Pull code blocks out before applying the other formatting markers.
  var codeBlocks = [];
  text = text.replace(/```([\s\S]*?)```/g, function(match, content) {
    var token = "\u0000WACODE" + codeBlocks.length + "\u0000";
    codeBlocks.push(content);
    return token;
  });

  text = text
    .replace(/\*([^*\n]+?)\*/g, "<strong>$1</strong>")
    .replace(/_([^_\n]+?)_/g, "<em>$1</em>")
    .replace(/~([^~\n]+?)~/g, "<s>$1</s>")
    .replace(/\r?\n/g, "<br>");

  text = text.replace(/\u0000WACODE(\d+)\u0000/g, function(match, index) {
    return "<code>" + codeBlocks[Number(index)] + "</code>";
  });

  return text;
}

export function whatsappPlainText(message) {
  return String(message == null ? "" : message)
    .replace(/```/g, "")
    .replace(/\*/g, "")
    .replace(/_/g, "")
    .replace(/~/g, "")
    .trim();
}

export function whatsappPreviewVariables() {
  var now = new Date();
  var previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  var monthNames = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ];

  return {
    first_name: "Andi",
    last_name: "Pratama",
    phone_number: "6281234567890",
    email: "andi@example.com",
    month_current: String(now.getMonth() + 1),
    month_current_name: monthNames[now.getMonth()],
    year_current: String(now.getFullYear()),
    today: String(now.getDate()),
    yesterday: String(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getDate()),
    month_ago: String(previousMonth.getMonth() + 1),
    month_ago_name: monthNames[previousMonth.getMonth()],
    year_ago: String(now.getFullYear() - 1)
  };
}

export function safeAttachmentUrl(value) {
  var url = String(value == null ? "" : value).trim();
  if (!url) return "";
  if (/^(https?:)?\/\//i.test(url) || /^data:image\//i.test(url)) {
    return url;
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/utils/whatsappMessage.js